var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowPolyGridHaikei(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.3 359L638.9 240L515.3 238Z",
    fill: "#db507e",
    stroke: "#db507e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3 359L640.9 361L638.9 240Z",
    fill: "#dd5b87",
    stroke: "#dd5b87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.4 242L640.9 123L638.9 240Z",
    fill: "#d94978",
    stroke: "#d94978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.9 240L640.9 123L515.3 238Z",
    fill: "#d84575",
    stroke: "#d84575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.9 123L511.3 123L515.3 238Z",
    fill: "#d94978",
    stroke: "#d94978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3 238L386.7 236L515.3 359Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7 363L513.3 481L515.3 359Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3 359L513.3 481L640.9 361Z",
    fill: "#dc5884",
    stroke: "#dc5884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.3 481L642.9 480L640.9 361Z",
    fill: "#d53369",
    stroke: "#d53369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.9 361L769.4 242L638.9 240Z",
    fill: "#d84575",
    stroke: "#d84575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.3 123L386.7 236L515.3 238Z",
    fill: "#dc5884",
    stroke: "#dc5884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.4 359L769.4 242L640.9 361Z",
    fill: "#db507e",
    stroke: "#db507e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7 236L381.7 363L515.3 359Z",
    fill: "#d73c6f",
    stroke: "#d73c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.9 480L773.4 359L640.9 361Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.3 123L387.7 119L386.7 236Z",
    fill: "#d73c6f",
    stroke: "#d73c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7 236L257.1 359L381.7 363Z",
    fill: "#dd5b87",
    stroke: "#dd5b87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3 0L387.7 119L511.3 123Z",
    fill: "#d53369",
    stroke: "#d53369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.4 242L770.4 123L640.9 123Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.9 123L515.3 0L511.3 123Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 241L770.4 123L769.4 242Z",
    fill: "#d94978",
    stroke: "#d94978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7 363L381.7 481L513.3 481Z",
    fill: "#d53369",
    stroke: "#d53369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.4 600L772.4 481L642.9 480Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.9 480L772.4 481L773.4 359Z",
    fill: "#dd5b87",
    stroke: "#dd5b87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.9 0L515.3 0L640.9 123Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.4 123L640.9 0L640.9 123Z",
    fill: "#d84575",
    stroke: "#d84575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.3 481L639.9 600L642.9 480Z",
    fill: "#db5481",
    stroke: "#db5481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.3 600L639.9 600L513.3 481Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7 600L511.3 600L513.3 481Z",
    fill: "#db507e",
    stroke: "#db507e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7 363L257.1 479L381.7 481Z",
    fill: "#dd5b87",
    stroke: "#dd5b87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.1 237L257.1 359L386.7 236Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1 122L386.7 236L387.7 119Z",
    fill: "#dd5b87",
    stroke: "#dd5b87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1 122L255.1 237L386.7 236Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 359L900 241L773.4 359Z",
    fill: "#db5481",
    stroke: "#db5481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.4 359L900 241L769.4 242Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.4 123L773.4 0L640.9 0Z",
    fill: "#dc5884",
    stroke: "#dc5884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 480L900 359L773.4 359Z",
    fill: "#d84575",
    stroke: "#d84575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.3 0L382.7 0L387.7 119Z",
    fill: "#dc5884",
    stroke: "#dc5884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7 481L386.7 600L513.3 481Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1 600L386.7 600L381.7 481Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 120L773.4 0L770.4 123Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.9 600L769.4 600L642.9 480Z",
    fill: "#dd5b87",
    stroke: "#dd5b87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.4 481L900 480L773.4 359Z",
    fill: "#d73c6f",
    stroke: "#d73c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7 0L258.1 122L387.7 119Z",
    fill: "#db507e",
    stroke: "#db507e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1 600L257.1 479L128.6 483Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1 359L257.1 479L381.7 363Z",
    fill: "#d53369",
    stroke: "#d53369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 241L900 120L770.4 123Z",
    fill: "#db5481",
    stroke: "#db5481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 600L900 480L772.4 481Z",
    fill: "#db5481",
    stroke: "#db5481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6 241L129.6 359L255.1 237Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7 0L254.1 0L258.1 122Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 120L900 0L773.4 0Z",
    fill: "#d84575",
    stroke: "#d84575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6 359L257.1 479L257.1 359Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1 479L253.1 600L381.7 481Z",
    fill: "#db5481",
    stroke: "#db5481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6 359L257.1 359L255.1 237Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.4 600L900 600L772.4 481Z",
    fill: "#d73c6f",
    stroke: "#d73c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6 241L255.1 237L126.6 117Z",
    fill: "#dc5884",
    stroke: "#dc5884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 117L255.1 237L258.1 122Z",
    fill: "#dd5b87",
    stroke: "#dd5b87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 481L128.6 483L129.6 359Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6 359L128.6 483L257.1 479Z",
    fill: "#d94978",
    stroke: "#d94978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1 0L126.6 117L258.1 122Z",
    fill: "#db507e",
    stroke: "#db507e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.1 0L126.6 0L126.6 117Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 237L0 359L125.6 241Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 481L124.6 600L128.6 483Z",
    fill: "#d53369",
    stroke: "#d53369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6 483L124.6 600L253.1 600Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6 241L0 359L129.6 359Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 237L125.6 241L126.6 117Z",
    fill: "#d73c6f",
    stroke: "#d73c6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 117L0 237L126.6 117Z",
    fill: "#d74172",
    stroke: "#d74172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 0L0 117L126.6 117Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 359L0 481L129.6 359Z",
    fill: "#da4d7b",
    stroke: "#da4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6 0L0 0L0 117Z",
    fill: "#d53369",
    stroke: "#d53369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 481L0 600L124.6 600Z",
    fill: "#d6386c",
    stroke: "#d6386c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPolyGridHaikei);
export default __webpack_public_path__ + "static/media/low-poly-grid-haikei.d75d8259478e8069de8b45b5a3eaa55d.svg";
export { ForwardRef as ReactComponent };